import React from "react";
import { Route, Routes } from "react-router-dom";
import Login from "../../Pages/Login/Login";
import Layout from "../../Pages/Layout/Index.jsx";
import FarmerRegister from "../../Pages/FarmerRegisterForm/Index";
import ExcelUpload from "../../Pages/ExcelUpload/index.jsx";
import ComplaintRegister from "../../Pages/ComplaintRegister/Index.jsx";
import ComplaintList from "../../Pages/ComplaintList/Index.jsx";
import ComplaintDetails from "../../Pages/ComplaintDetails/Index.jsx";
import Report from "../../Pages/Report/index.jsx";
import VerifyComplaint from "../../Pages/verifyComplaint/Index.jsx";
import EmployeeRegister from "../../Pages/EmployeeRegistration/index.jsx";
import ShowFarmerDataDashboard from "../../Pages/FarmerData/index.jsx";
import Dashboard from "../../Pages/Dashboard/Index.jsx";
import Permission from "../../Pages/Permission/Index.jsx";
import UpdatePhotoInfoPage from "../../Pages/UpdatePhotoInfo/index.jsx";
import QuarterlyVisit from "../../Pages/QuarterlyVisit/Index.jsx";
import NewFarmerData from "../../Pages/NewFarmerData/index.jsx";
import InstallationSurveyDetails from "../../Pages/InstallationSurveyDetails/Index.jsx";
import InstallationSurveyList from "../../Pages/InstallationSurveyList/Index.jsx";
import SendMessage from "../../Pages/WhatsApp/index.jsx";
import EmpTrack from "../../Pages/EmpTrack/index.jsx";
import Payment from "../../Pages/Account/Payment.jsx";
import MaharashtraComplaintRegister from "../../Pages/Maharashtra/ComplaintRegister.jsx";
import MaharashtraComplaintList from "../../Pages/Maharashtra/complaintList.jsx";
import ComplaintStatus from "../../Pages/Maharashtra/ComplaintStatus.jsx";
import Insurance from "../../Pages/Insurance/Index.jsx";
import MaterialList from "../../Pages/MaharastraInstallationPersonData/InstallationPersonData.jsx";
import InstallationList from "../../Pages/InstallationDataMaharastra/ShowDataMaharastra.jsx";
import ApprovedList from "../../Pages/ShowApprovedInstallationData/ApprovedDataMaharastra.jsx";
import InstallationDone from "../../Pages/CompleteInstallationMaharastra/CompleteInstallationMaharastra.jsx";
import InstallationMaharashtra from "../../Pages/NewInstallationMaharastra/InstallationMaharashtra.jsx";
import InstalledList from "../../Pages/Insurance/InstalledList.jsx";
import InsuranceList from "../../Pages/Account/InsuranceList.jsx"; // account
import ShowImages from "../../Pages/showImages/Index.jsx";
import InstallerList from "../../Pages/installer/InstallerList.jsx";
import AddInstaller from "../../Pages/installer/AddInstaller.jsx";
import PaymentRequest from "../../Pages/installer/PaymentRequest.jsx";
import PaymentListForAccount from "../../Pages/Account/PaymentListForAccount.jsx";
import ApprovedMeterList from "../../Pages/EmpTrack/Vehicle/ApprovedMeterList.jsx";
import FarmerExpired from "../../Pages/FarmerData/FarmerExpired.jsx";
import GeneratePDF from "../../Pages/Admin/GeneratePDF.jsx";
import UploadInvoice from "../../Pages/Admin/UploadInvoice.jsx";
import ChangePassword from "../../Pages/ChangePassword/Index.jsx";
import QualitySurveyList from "../../Pages/QualitySurveyList/Index.jsx";
import MhAssignInstallation from "../../Pages/MhInstallationAssignPerson/MhAssignInstallation.jsx";
import ServicePersonRegistration from "../../Pages/ServicePerson/ServicePersonRegistration.jsx";
import ShowAllServicePerson from "../../Pages/ServicePerson/ShowAllServicePerson.jsx";
import EditServicePerson from "../../Pages/ServicePerson/EditServicePerson.jsx";
import VerifyImage from "../../Pages/VerificationImage/VerifyImage.jsx";
import VerifiedImageHistory from '../../Pages/VerificationImage/VerifiedImageHistory.jsx'
import EnquiryList from "../../Pages/CRM/EnquiryList.jsx";
import Rmu from "../../Pages/Rmu/index.jsx";
import NewInstallationHistory from "../../Pages/NewInstallationHistory/NewInstallationHistory.jsx";

const Index = () => {
  // const Navigate = useNavigate();
  // useEffect(() => {
  //   const token = getCookie('token');
  //   if(!token){
  //     Navigate('/login');
  //   }
  // }, []);
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route
        path="/complaint-register"
        element={<MaharashtraComplaintRegister />}
      />
      <Route path="/complaint-status" element={<ComplaintStatus />} />
      <Route path="/" element={<Layout />}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="farmerRegister" element={<FarmerRegister />} />
        <Route path="complaintRegister" element={<ComplaintRegister />} />
        <Route path="excelUpload" element={<ExcelUpload />} />
        <Route path="complaintList" element={<ComplaintList />} />
        <Route path="complaintList/:id" element={<ComplaintList />} />
        <Route path="complaintDetails" element={<ComplaintDetails />} />
        <Route path="verifyComplaint" element={<VerifyComplaint />} />
        <Route path="report" element={<Report />} />
        <Route path="employeeRegister" element={<EmployeeRegister />} />
        <Route
          path="ShowFarmerDataDashboard"
          element={<ShowFarmerDataDashboard />}
        />
        <Route path="permission" element={<Permission />} />
        <Route path="udpatePhoto" element={<UpdatePhotoInfoPage />} />
        <Route path="QuarterlyVisit" element={<QuarterlyVisit />} />
        <Route path="newFarmer" element={<NewFarmerData />} />
        <Route
          path="installationSurveyDetails"
          element={<InstallationSurveyDetails />}
        />
        <Route
          path="installationSurveyList"
          element={<InstallationSurveyList />}
        />
        <Route path="WhatsAppPage" element={<SendMessage />} />
        <Route path="EmpTrack" element={<EmpTrack />} />
        <Route path="Account" element={<Payment />} />
        <Route
          path="MaharashtraComplaintRegister"
          element={<MaharashtraComplaintRegister />}
        />
        <Route
          path="MaharashtraComplaintList"
          element={<MaharashtraComplaintList />}
        />
        <Route path="MhAssignInstallation" element={<MhAssignInstallation />} />
        <Route path="insurance" element={<Insurance />} />
        <Route path="MaterialList" element={<MaterialList />} />
        <Route path="InstallationList" element={<InstallationList />} />
        <Route path="ApprovedList" element={<ApprovedList />} />
        <Route path="InstallationDone" element={<InstallationDone />} />
        <Route
          path="InstallationMaharashtra"
          element={<InstallationMaharashtra />}
        />
        <Route path="pendingInsuranceList" element={<InstalledList />} />
        <Route path="InsuranceList" element={<InsuranceList />} />
        <Route path="showImages" element={<ShowImages />} />
        <Route path="installerList" element={<InstallerList />} />
        <Route path="addInstaller" element={<AddInstaller />} />
        <Route path="paymentRequest" element={<PaymentRequest />} />
        <Route
          path="installerPaymentList"
          element={<PaymentListForAccount />}
        />
        <Route path="meterApprovedList" element={<ApprovedMeterList />} />
        <Route path="farmerExpired" element={<FarmerExpired />} />
        <Route path="GeneratePDF" element={<GeneratePDF />} />
        <Route path="UploadInvoice" element={<UploadInvoice />} />
        <Route path="change-password" element={<ChangePassword />} />
        <Route path="qualitySurveyList" element={<QualitySurveyList />} />
        <Route
          path="ServicePersonRegistration"
          element={<ServicePersonRegistration />}
        />
        <Route path="ShowAllServicePerson" element={<ShowAllServicePerson />} />
        <Route path="EditServicePerson" element={<EditServicePerson />} />
        <Route path="VerifyImage" element={<VerifyImage />} />
        <Route path="VerifiedImageHistory" element={<VerifiedImageHistory />} />
        <Route path="NewInstallationHistory" element={<NewInstallationHistory />} />
        <Route path="enquiryList" element={<EnquiryList />} />
        <Route path="rmu" element={<Rmu />} />
      </Route>
    </Routes>
  );
};

export default Index;
